package com.checkin.host.ui.components

import androidx.compose.runtime.Composable
import com.checkin.host.theme.AppColors
import com.checkin.host.theme.secondaryButton
import com.checkin.host.theme.primaryButton
import com.checkin.host.theme.cardStyle
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun FilterIconButton(
    expanded: Boolean,
    active: Boolean,
    onClick: () -> Unit,
) {
    Button({
        style {
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            justifyContent(JustifyContent.Center)
            width(36.px)
            height(36.px)
            padding(0.px)
            border(
                1.px,
                LineStyle.Solid,
                if (expanded || active) AppColors.primary else AppColors.border,
            )
            borderRadius(8.px)
            backgroundColor(
                if (expanded || active) Color(AppColors.navActiveBg) else AppColors.surface,
            )
            color(if (active) AppColors.primary else AppColors.textSub)
            cursor("pointer")
            position(Position.Relative)
            property("flex-shrink", "0")
            property("transition", "background 0.15s ease, border-color 0.15s ease")
        }
        attr("title", if (expanded) "Masquer les filtres" else "Afficher les filtres")
        attr("aria-label", "Filtres")
        attr("aria-expanded", if (expanded) "true" else "false")
        onClick { onClick() }
    }) {
        Div({
            style {
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
                alignItems(AlignItems.FlexEnd)
                gap(3.px)
                width(14.px)
            }
        }) {
            listOf(14, 10, 6).forEach { width ->
                Div({
                    style {
                        width(width.px)
                        height(2.px)
                        borderRadius(1.px)
                        backgroundColor(Color("currentColor"))
                    }
                })
            }
        }
        if (active && !expanded) {
            Div({
                style {
                    position(Position.Absolute)
                    property("top", "6px")
                    property("right", "6px")
                    width(6.px)
                    height(6.px)
                    borderRadius(50.percent)
                    backgroundColor(AppColors.primary)
                    property("pointer-events", "none")
                }
            })
        }
    }
}

@Composable
fun CollapsibleFilterPanel(
    isMobile: Boolean,
    applyLabel: String = "Appliquer",
    onApply: () -> Unit,
    onReset: () -> Unit,
    content: @Composable () -> Unit,
) {
    Div({
        style {
            cardStyle()
            marginBottom(20.px)
        }
    }) {
        Div({
            style {
                display(DisplayStyle.Grid)
                property(
                    "grid-template-columns",
                    if (isMobile) "1fr" else "repeat(auto-fit, minmax(150px, 1fr))",
                )
                gap(12.px)
                marginBottom(12.px)
            }
        }) {
            content()
        }
        Div({
            style {
                display(DisplayStyle.Flex)
                gap(8.px)
                flexWrap(FlexWrap.Wrap)
                if (isMobile) flexDirection(FlexDirection.Column)
            }
        }) {
            Button({
                style { primaryButton(); if (isMobile) width(100.percent) }
                onClick { onApply() }
            }) { Text(applyLabel) }
            Button({
                style { secondaryButton(); if (isMobile) width(100.percent) }
                onClick { onReset() }
            }) { Text("Réinitialiser") }
        }
    }
}
